import { FC, ReactNode } from 'react'
import { composeClasses } from '@/utils/compose-classes'

export interface ContainerDropdownFooterProps {
  children: ReactNode
  className?: string
}

export const _ContainerDropdownFooter: FC<ContainerDropdownFooterProps> = ({
  children,
  className
}) => {
  return (
    <div
      data-testid="dropdown-footer"
      className={composeClasses(className, 'w-full pt-4 px-4')}
    >
      {children}
    </div>
  )
}
